import React from 'react';
import bem from '../../_utils/bem';
import BackgroundImage from '../../01-atoms/images/BackgroundImage/BackgroundImage.component';
import { imageTypeProps } from '../../01-atoms/images/Image/Image.component';
import Heading from '../../01-atoms/text/Heading.component';
import Paragraph from '../../01-atoms/text/Paragraph.component';

var Hero = function Hero(_ref) {
  var _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'hero' : _ref$block,
      outputImage = _ref.outputImage,
      image = _ref.image,
      heading = _ref.heading,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(BackgroundImage, {
    block: block,
    outputImage: outputImage,
    image: image
  }, /*#__PURE__*/React.createElement("div", {
    className: bem(block, 'content-inner')
  }, heading && /*#__PURE__*/React.createElement(Heading, {
    level: "1",
    block: block,
    element: "heading"
  }, heading), children && /*#__PURE__*/React.createElement(Paragraph, null, children)));
};

export default Hero;